var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"my-3",attrs:{"rounded":"lg","outlined":"","data-test":"TodoListItemSkeleton"}},[_c('v-skeleton-loader',{attrs:{"type":"list-item-avatar-three-line"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }